"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveChatNotificationApiSettingsBase = void 0;
const AlmeApiSettingsBase_1 = require("../Alme/AlmeApiSettingsBase");
class LiveChatNotificationApiSettingsBase extends AlmeApiSettingsBase_1.AlmeApiSettingsBase {
    constructor() {
        super(...arguments);
        /**
         * Alme REST API get notification request endpoint path.
         *
         * @default "Notification/GetNotifications"
         * @deprecated - Only applies to Alme 5.X environments with Notification extension. Newer releases should use {@link AlmeApiSettingsBase.AlmeApiGetPendingMessagesEndpoint}
         */
        this.AlmeApiNotificationEndpoint = 'Notification/GetNotifications';
        /**
         * Alme REST API live chat get notification request endpoint path.
         *
         * @default "LiveChat/GetNotification"
         */
        this.AlmeApiLiveChatNotificationEndpoint = 'LiveChat/GetNotifications';
    }
}
exports.LiveChatNotificationApiSettingsBase = LiveChatNotificationApiSettingsBase;
//# sourceMappingURL=LiveChatNotificationApiSettingsBase.js.map